import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { select, Store } from '@ngrx/store';

import { each, has } from 'lodash-es';
import { Observable } from 'rxjs';

import { CoreConfig } from '../../core.module';
import { GenericComponent } from '../../misc/components/generic/generic.component';
import * as fromDeviceSelectors from '../../store/selectors/device.selectors';
import * as fromSettingSelectors from '../../store/selectors/setting.selectors';
import { FormValidationErrors } from '../../typings/form-validation-errors';
import * as fromSettingActions from './../../store/actions/setting.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-referral',
  standalone: false,
  templateUrl: './referral.page.html'
})
export class ReferralPageComponent extends GenericComponent {
  private coreConfig = inject<CoreConfig>(CoreConfig);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private store = inject(Store);

  appVersion$: Observable<string>;
  environment: string;
  referralForm: FormGroup = new FormGroup({
    code: new FormControl<string>('', Validators.required)
  });
  referralFormValidationErrors: FormValidationErrors = {};

  constructor() {
    super();
    this.appVersion$ = this.store.pipe(select(fromDeviceSelectors.selectAppVersion));
    this.environment = this.coreConfig.production ? 'Release' : 'Test';
  }

  ionViewDidEnter() {
    this.referralForm.reset();
    this.addUniqueSubscription(
      'formValidationErrors',
      this.store
        .pipe(select(fromSettingSelectors.selectReferralFormValidationErrors))
        .subscribe((formValidationErrors) => {
          this.referralFormValidationErrors = formValidationErrors;
          const controlNames = ['code'];
          each(controlNames, (controlName) => {
            const control = this.referralForm.get(controlName);
            if (has(this.referralFormValidationErrors, controlName)) {
              control?.setErrors(this.referralFormValidationErrors[controlName]);
            } else {
              control?.setErrors(null);
            }
          });
          this.changeDetectorRef.detectChanges();
        })
    );
  }

  onSubmit() {
    this.store.dispatch(
      fromSettingActions.loadSettings({
        payload: { isOnboardFlow: true, referralCode: this.referralForm?.get('code')?.value }
      })
    );
  }
}
